
const digest = '4513f92c2c35aa22a0c99b20178685f5760ed06ecccb6ea81bce2f41ab585824';
const classes = {"wrapper":"_wrapper_1j28z_1","title":"_title_1j28z_10","maxContent":"_maxContent_1j28z_17","optional":"_optional_1j28z_21"};
const css = `._wrapper_1j28z_1 {
  font-family: Poppins, sans-serif;
  padding-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

._title_1j28z_10 {
  color: #212357 !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  padding-left: 20px !important;
}

._maxContent_1j28z_17 {
  width: max-content;
}

._optional_1j28z_21 {
  display: inline-block;
  font-size: 10px;
  font-weight: 500;
  color: #909090;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  